import { colors } from '@ardoq/design-tokens';

export const TOOLTIP_SELECTOR = '[data-tooltip-text]';
export const TOOLTIP_DELAY = 150;
export const TOOLTIP_BG_COLOR = colors.surfaceInverted;
